export default __webpack_public_path__ + "static/blob-52-36abef562ebf5e4190b78b85abdb339c.svg";